module.exports = __webpack_public_path__ + "img/daka_def_bg.59aa6ffc.png";